module.exports = __webpack_public_path__ + "img/GitHub-Mark.07883e93.svg";